import styled from '@emotion/styled'
import styles, { typo } from '@mathflat/common/style'

const {
  colors: { red },
} = styles
const WarningModalStyled = styled.div`
  width: 494px;
  padding: 24px;
  .warning-modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px; /* 예외 */
    > img {
      width: 24px;
      height: 24px;
    }
    > h2 {
      margin-left: 8px;
      ${typo.heading05};
      color: ${red.$300};
      font-weight: 700;
    }
  }
  .warning-modal-body {
    text-align: center;
  }
  .warning-modal-footer {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    > button {
      width: 100px;
      & + button {
        margin-left: 8px;
      }
    }
  }
`
export default WarningModalStyled
